import { InjectionToken } from '@angular/core';

export interface NovuIdentity {
  subscriberId: string;
  subscriberHash: string;
  applicationIdentifier: string;
  apiUrl: string;
  socketUrl: string;
}

// Solo el provider server-only (ver `provideNovuIdentity`, registrado en
// app.config.server.ts) sobreescribe este token, consumiendo AuthService/
// TENANTS_STATE_TOKEN (igual que menu.provider.ts y tenant.provider.ts). En
// el cliente conserva el valor por defecto (null); `NovuService` lo hidrata
// desde TransferState en vez de recalcularlo.
export const NOVU_IDENTITY_TOKEN = new InjectionToken<NovuIdentity | null>(undefined, {
  providedIn: 'root',
  factory: () => null,
});
